import { Modal, OverlayTrigger, Tooltip } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { my_routes } from "../router/all_routes";
import { toast } from "sonner";
import { useEffect, useState } from "react";
import EdtDuplicateModal from "./edt_duplicate_modal";
import { deleteEDT, publishEDTVersion } from "../../api/edt";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import withPermission from "../../core/common/autorisations/withPermission";
import {
  Action,
  buildPermission,
  Resource,
} from "../../core/common/autorisations/permissionsMap";

import EdtEditModal from "./edt_edit_modal";
import { Popconfirm } from "antd";

type Props = {
  show: boolean;
  selectedSchedule: any;
  onClose: () => void;
  onSaved?: () => void;
};

type ScheduleVersion = {
  id: string;
  versionNumber: string;
  createdAt: string;
  isPublished: boolean;
};

// Bouton protégé pour modifier un EDT
const ProtectedBtnUpdateEDT = withPermission(
  (props: any) => (
    <button
      className="btn btn-info mx-2"
      onClick={() => props.setShowUpdate(true)}
    >
      Modifier EDT
    </button>
  ),
  [buildPermission(Resource.EDT, Action.UPDATE)],
  "masquer",
);

// Bouton protégé pour supprimer un EDT
const ProtectedBtnDeleteEDT = withPermission(
  (props: any) => (
    <button
      className="btn btn-danger"
      onClick={() => props.showdeleteEDTConfirmationAlert()}
    >
      Supprimer EDT
    </button>
  ),
  [buildPermission(Resource.EDT, Action.DELETE)],
  "masquer",
);

// Bouton protégé pour publier une version d'EDT
const ProtectedBtnPublishVersion = withPermission(
  (props: any) => (
    <Popconfirm
      title={`Êtes-vous sûr de vouloir ${props.version?.isPublished ? "dépublier" : "publier"} cette version ?`}
      onConfirm={() => {
        // console.log("Clique sur le btn de publication/depublication");
        props.handlePublishVersion(props.versionId);
      }}
      okText="Oui"
      cancelText="Non"
    >
      <button
        className="btn btn-sm d-flex align-items-center text-blue"
        style={{ fontSize: "15px" }}
      >
        <i
          className={` ${
            props.version?.isPublished
              ? "ion-icon ion-eye-disabled"
              : "ti ti-eye"
          } me-1`}
          style={{ fontSize: "20px" }}
        ></i>{" "}
        {props.version?.isPublished ? "Dépublier" : "Publier"}
      </button>
    </Popconfirm>
  ),
  [buildPermission(Resource.EDT, Action.UPDATE)],
  "masquer",
);

// Bouton protégé pour dupliquer une version d'EDT
const ProtectedBtnDuplicateEDT = withPermission(
  (props: any) => (
    <button
      className="btn btn-sm d-flex align-items-center text-blue"
      style={{ fontSize: "15px" }}
      onClick={() => {
        props.setDuplicateScheduleId(props.selectedSchedule.id);
        props.setDuplicateVersionId(props.version.id);
        props.setShowDuplicateModal((prev: any) => !prev);
      }}
    >
      <i className="ti ti-copy me-1" style={{ fontSize: "20px" }}></i> Dupliquer
    </button>
  ),
  [buildPermission(Resource.EDT, Action.CREATE)],
  "masquer",
);

const EdtVersionModal = ({
  show,
  onClose,
  selectedSchedule,
  onSaved,
}: Props) => {
  const routes = my_routes;
  const navigate = useNavigate();

  const [showDuplicateModal, setShowDuplicateModal] = useState<boolean>(false);
  const [duplicateSheduleId, setDuplicateScheduleId] = useState<string>("");
  const [duplicateVersionId, setDuplicateVersionId] = useState<string>("");

  const [showEditModal, setShowEditModal] = useState<boolean>(false);

  // Fonction pour naviguer vers la page de détails d'une version
  const viewVersionDetails = (scheduleId: string, versionId: string) => {
    navigate(
      `${routes.timeTableManager}?id=${scheduleId}&version=${versionId}`,
    );
  };

  const handlePublishVersion = async (versionId: string) => {
    try {
      // Appel API pour publier la version
      const response = await publishEDTVersion(versionId);
      // console.log("Response: ", response);
      toast.success(
        response?.message || "Statut de la version changer avec succès",
      );
      // Rafraîchir la liste des versions ou mettre à jour l'état local
      if (onSaved) onSaved();
      // onClose();
    } catch (error: any) {
      // console.log("Erreur lors de la pubication de la version: ", error);
      toast.error(
        error.response?.data?.message ||
          error.response?.data?.error ||
          error.message ||
          "Une erreur s'est produit, Réessayer plus tard",
      );
    }
  };

  //Initialisation de sweetAlert
  const MySwal = withReactContent(Swal);
  // alert pour supprimer un EDT
  const showdeleteEDTConfirmationAlert = () => {
    MySwal.fire({
      title: "Supprimer parent ?",
      text: `Voulez-vous vraiment supprimer ${selectedSchedule?.nom}?`,
      showCancelButton: true,
      confirmButtonText: "Supprimer",
      cancelButtonText: "Annuler",
    }).then(async (result) => {
      if (result.isConfirmed) {
        // ── Affiche le spinner pendant la requête ──
        MySwal.fire({
          title: "Suppression en cours...",
          allowOutsideClick: false,
          allowEscapeKey: false,
          showConfirmButton: false,
          didOpen: () => MySwal.showLoading(),
        });
        try {
          //On lance la requête de suppression
          await deleteEDT(selectedSchedule?.id);
          MySwal.fire({
            title: "Emploi du temps supprimé avec succès !",
            icon: "success",
            confirmButtonText: "OK",
          });
          if (onSaved) onSaved();
          onClose();
        } catch (error) {
          //On affiche une alerte en cas d'erreur côté serveur
          MySwal.fire({
            title: "Erreur",
            text: "Échec de la suppression de l'emploi du temps. Veuillez réessayer.",
            icon: "error",
            confirmButtonText: "OK",
          });
        }
      }
    });
  };

  return (
    <>
      <Modal
        show={show}
        onHide={onClose}
        size="xl"
        centered
        // dialogClassName="h-90"
        style={{ maxHeight: "90vh", overflowY: "auto" }}
      >
        <Modal.Header closeButton>
          <Modal.Title className="d-flex align-items-center gap-4">
            <i className="ion ion-clock fs-2"></i>
            <h5 className="modal-title">
              {selectedSchedule.nom} ({selectedSchedule?.startDate} -{" "}
              {selectedSchedule?.endDate})
            </h5>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="versions-container">
            <div className="d-flex justify-content-between align-items-center">
              {" "}
              <h6 className="mb-3">Historique des versions</h6>
              <div>
                <ProtectedBtnUpdateEDT setShowUpdate={setShowEditModal} />
                <ProtectedBtnDeleteEDT
                  showdeleteEDTConfirmationAlert={
                    showdeleteEDTConfirmationAlert
                  }
                />
              </div>
            </div>
            <div>
              <div
                className="timeline-track"
                style={{
                  position: "relative",
                  padding: "20px 0",
                }}
              >
                <div className="table-responsive">
                  <table
                    className="table"
                    style={{
                      border: "none",
                      textAlign: "center",
                      borderCollapse: "collapse",
                    }}
                  >
                    <thead style={{ borderBottom: "1px solid #dee2e6" }}>
                      <tr style={{ border: "none" }}>
                        <th style={{ border: "none" }}>#</th>
                        <th style={{ border: "none" }}>Version</th>
                        <th style={{ border: "none" }}>Créée le</th>
                        <th style={{ border: "none" }}></th>
                        <th style={{ border: "none" }}>
                          Dernière modification
                        </th>
                        <th style={{ border: "none" }}>Status</th>

                        <th style={{ border: "none" }}></th>
                      </tr>
                    </thead>
                    <tbody>
                      {selectedSchedule.versions
                        .sort((a: ScheduleVersion, b: ScheduleVersion) =>
                          b.versionNumber.localeCompare(a.versionNumber),
                        )
                        .map((version: ScheduleVersion, index: number) => (
                          <tr key={version.id} style={{ border: "none" }}>
                            <OverlayTrigger
                              placement="top"
                              overlay={
                                <Tooltip id="tooltip-top">{version.id}</Tooltip>
                              }
                            >
                              <td
                                style={{
                                  border: "none",
                                  maxWidth: 80,
                                  textOverflow: "ellipsis",
                                  overflow: "hidden",
                                  whiteSpace: "nowrap",
                                }}
                              >
                                {version.id}
                              </td>
                            </OverlayTrigger>
                            <td style={{ border: "none" }}>
                              {version.versionNumber}
                            </td>
                            <td style={{ border: "none" }}>
                              {new Date(version.createdAt).toLocaleString(
                                "fr-FR",
                                {
                                  weekday: "short",
                                  day: "2-digit",
                                  month: "2-digit",
                                  // hour: "2-digit",
                                  // minute: "2-digit",
                                  // hour12: false,
                                },
                              )}
                            </td>
                            <td
                              style={{
                                border: "none",
                                padding: "auto",
                                textAlign: "center",
                                verticalAlign: "middle",
                              }}
                            >
                              <div
                                key={version.id}
                                className="timeline-item d-flex justify-content-center align-items-center"
                                style={{
                                  display: "inline-flex",
                                  position: "relative",
                                  marginBottom: "30px",
                                  paddingLeft: "50px",
                                  cursor: "pointer",
                                  verticalAlign: "middle",
                                }}
                                onClick={() =>
                                  viewVersionDetails(
                                    selectedSchedule.id,
                                    version.id,
                                  )
                                }
                              >
                                <div
                                  className="timeline-point"
                                  style={{
                                    position: "absolute",
                                    top: "10px",
                                    width: "15px",
                                    height: "15px",
                                    borderRadius: "50%",
                                    backgroundColor: version.isPublished
                                      ? "#28a745"
                                      : "#6c757d",
                                    border: "3px solid #fff",
                                    boxShadow:
                                      "0 0 0 3px " +
                                      (version.isPublished
                                        ? "#28a74544"
                                        : "#6c757d44"),
                                  }}
                                />
                                <div
                                  className="timeline-line"
                                  style={{
                                    position: "absolute",
                                    top: "30px",
                                    bottom: "-60px",
                                    width: "2px",
                                    backgroundColor:
                                      index ===
                                      selectedSchedule.versions.length - 1
                                        ? "transparent"
                                        : "#e9ecef",
                                  }}
                                />
                              </div>
                            </td>
                            <td style={{ border: "none" }}>
                              {new Date(version.createdAt).toLocaleString(
                                "fr-FR",
                                {
                                  weekday: "short",
                                  day: "2-digit",
                                  month: "2-digit",
                                  // hour: "2-digit",
                                  // minute: "2-digit",
                                  // hour12: false,
                                },
                              )}
                            </td>
                            <td style={{ border: "none" }}>
                              {version.isPublished ? (
                                <span className="badge bg-success">
                                  Publiée
                                </span>
                              ) : (
                                <span className="badge bg-secondary">
                                  Non publiée
                                </span>
                              )}
                            </td>

                            <td style={{ border: "none" }}>
                              <ProtectedBtnPublishVersion
                                handlePublishVersion={handlePublishVersion}
                                version={version}
                                versionId={version.id}
                              />
                            </td>
                            <td style={{ border: "none" }}>
                              <ProtectedBtnDuplicateEDT
                                setDuplicateScheduleId={setDuplicateScheduleId}
                                setDuplicateVersionId={setDuplicateVersionId}
                                setShowDuplicateModal={setShowDuplicateModal}
                                selectedSchedule={selectedSchedule}
                                version={version}
                              />
                            </td>
                          </tr>
                        ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button type="button" className="btn btn-light" onClick={onClose}>
            Fermer
          </button>
        </Modal.Footer>
      </Modal>

      <EdtDuplicateModal
        show={showDuplicateModal}
        idEDT={duplicateSheduleId}
        idVersionEDT={duplicateVersionId}
        onClose={() => setShowDuplicateModal(false)}
        onSave={() => {
          if (onSaved) onSaved();
        }}
      />

      <EdtEditModal
        show={showEditModal}
        dataEDT={selectedSchedule}
        onClose={() => setShowEditModal(false)}
        onSave={() => {
          if (onSaved) onSaved();
        }}
      />
    </>
  );
};

export default withPermission(
  EdtVersionModal,
  [
    ...Object.values(Action).map((action) =>
      buildPermission(Resource.EDT, action),
    ),
  ],
  "masquer",
);
